<template lang="pug">
    div
      main-header(
      :class="{'header_fixed': isPending}"
      )
      .preloader-gif(
      v-if="isPending"
      )
      router-view
      notification-modal(
        v-if="notificationModal"
        @close="notificationModal = false"
        :text="notificationData.text"
        :width-type="notificationData.widthType"
        :text-float="notificationData.textFloat"
      )
      errors-modal(
        v-if="errorModal"
        @close="errorModal = false"
        :text="errorModalText"
      )
      confirm-modal(
        v-if="confirmModal"
        @close="confirmModal = false"
        :title="confirmModalTitle"
        :text="confirmModalText"
        :button-confirm-func="confirmModalFunc"
        :button-confirm-text="buttonConfirmText"
        :button-cancel-text="buttonCancelText"
      )
</template>

<script>
import MainHeader from "@/components/header/Header.vue";
import NotificationModal from "@/components/modals/NotificationModal.vue";
import ErrorsModal from "@/components/modals/ErrorModal.vue";
import ConfirmModal from "@/components/modals/ConfirmModal.vue";

export default {
  name: "Pages",
  components: {
    ConfirmModal,
    MainHeader,
    NotificationModal,
    ErrorsModal
  },
  data: () => ({
    isPending: false,
    notificationModal: false,
    notificationData: {
      text: "",
      widthType: "small", // small, big
      textFloat: "center" // center, left
    },
    notificationModalText: "",
    errorModal: false,
    errorModalText: "",
    confirmModal: false,
    confirmModalText: "",
    confirmModalTitle: "",
    confirmModalFunc: "",
    buttonConfirmText: "",
    buttonCancelText: ""
  }),
  methods: {
    showNotificationModal(data) {
      this.notificationData.text = data.text;
      this.notificationData.widthType = data.widthType;
      this.notificationData.textFloat = data.textFloat;
      this.notificationModal = true;
    },
    showErrorModal(data) {
      this.errorModalText = data.text;
      this.errorModal = true;
    },
    showConfirmModal(data) {
      this.confirmModalText = data.text;
      this.confirmModalTitle = data.title;
      this.confirmModal = true;
      this.confirmModalFunc = data.buttonConfirmFunc || {};
      this.buttonConfirmText = data.buttonConfirmText;
      this.buttonCancelText = data.buttonCancelText;
    }
  },
  mounted() {
    this.$root.$on("onShowNotificationModal", data => {
      this.showNotificationModal(data);
    });
    this.$root.$on("onShowErrorModal", data => {
      this.showErrorModal(data);
    });
    this.$root.$on("onShowConfirmModal", data => {
      this.showConfirmModal(data);
    });
  },
  created() {
    this.$root.$on("on-show-preloader", () => {
      this.isPending = true;
    });
    this.$root.$on("on-hide-preloader", () => {
      this.isPending = false;
    });
  },
  beforeDestroy() {
    this.$root.$off("onShowErrorModal");
    this.$root.$off("on-show-preloader");
    this.$root.$off("on-hide-preloader");
  }
};
</script>
